import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface ILoaderState {
    /** Mostra o overlay: há requisição com `meta.showLoader` pendente. */
    loading: boolean
    /** Requisições com `meta.showLoader` em andamento (ver `attachLoaderInterceptors` no ApiService). */
    requestCount: number
    startLoading: () => void
    stopLoading: () => void
    resetStore: () => void
}

const initialState = {
    loading: false,
    requestCount: 0,
}

export const useLoaderStore = create<ILoaderState>()(
    devtools(
        (set, get) => ({
            ...initialState,
            startLoading: () => {
                const requestCount = get().requestCount + 1
                set({ requestCount, loading: true }, false, 'startLoading')
            },
            stopLoading: () => {
                const requestCount = Math.max(0, get().requestCount - 1)
                set({ requestCount, loading: requestCount > 0 }, false, 'stopLoading')
            },
            resetStore: () => set(initialState, false, 'resetStore'),
        }),
        { name: 'loader-store' },
    ),
)
